export const apiShippingMethodFreeShipping = {
    amount: {
        currency: "EUR",
        value: 0,
    },
    available: true,
    disable_for_subscription: false,
    base_amount: null,
    carrier_code: "freeshipping",
    carrier_title: "Free Shipping",
    method_code: "freeshipping",
    method_title: "Free",
    description: null,
    price_excl_tax: {
        currency: "EUR",
        value: 0,
    },
    price_incl_tax: {
        currency: "EUR",
        value: 0,
    },
};
export const apiShippingMethodRoyalMail = {
    amount: {
        currency: "EUR",
        value: 2.99,
    },
    available: true,
    disable_for_subscription: true,
    base_amount: null,
    carrier_code: "tablerate",
    carrier_title: "Tracked",
    method_code: "bestway",
    method_title: "Royal Mail - Tracked - 1 Day Service",
    description: null,
    price_excl_tax: {
        currency: "EUR",
        value: 2.99,
    },
    price_incl_tax: {
        currency: "EUR",
        value: 2.99,
    },
};
export const apiShippingMethodFedex = {
    available: true,
    disable_for_subscription: false,
    carrier_code: "fedex",
    carrier_title: "FedEx",
    method_code: "ground",
    method_title: "Ground",
    description: "Delivery in 5-7 business days",
    amount: {
        value: 10,
        currency: "USD",
    },
    base_amount: {
        value: 10,
        currency: "USD",
    },
    price_excl_tax: {
        value: 10,
        currency: "USD",
    },
    price_incl_tax: {
        value: 12,
        currency: "USD",
    },
};
export const apiShippingMethodShipToStore = {
    amount: {
        currency: "EUR",
        value: 0,
    },
    available: true,
    disable_for_subscription: true,
    base_amount: null,
    carrier_code: "jti_pickup",
    carrier_title: "Ship to store",
    method_code: "jti_pickup_2",
    method_title: "Method15",
    description: null,
    price_excl_tax: {
        currency: "EUR",
        value: 0,
    },
    price_incl_tax: {
        currency: "EUR",
        value: 0,
    },
};
export const mockApiShippingMethods = [
    apiShippingMethodFreeShipping,
    apiShippingMethodRoyalMail,
    apiShippingMethodFedex,
    apiShippingMethodShipToStore,
];
//# sourceMappingURL=shippingMethods.mock.js.map